export const isDateAfterNow = (date: Date): boolean => {
  const now = new Date();
  const toCheck = new Date(date);

  return now < toCheck;
};
